// extracted by mini-css-extract-plugin
export var active = "header-module--active--523ed";
export var author = "header-module--author--af598";
export var category = "header-module--category--63023";
export var closeIcon = "header-module--close-icon--440d8";
export var header = "header-module--header--7aa84";
export var headline = "header-module--headline--b751d";
export var headlinePost = "header-module--headline-post--5906b";
export var languageSwitch = "header-module--language-switch--0e5b6";
export var logo = "header-module--logo--86b79";
export var mobileMenu = "header-module--mobile-menu--cc6fd";
export var mobileMenuIcon = "header-module--mobile-menu-icon--be6ad";
export var mobileMenu__content = "header-module--mobile-menu__content--9ea5c";
export var mobileMenu__contentWrapper = "header-module--mobile-menu__content-wrapper--df5b3";
export var mobileMenu__header = "header-module--mobile-menu__header--37145";
export var navigation = "header-module--navigation--9dcea";
export var paragraph = "header-module--paragraph--c2f4b";
export var search = "header-module--search--8514b";